import React, { useContext } from 'react'
import { GlobalContext } from 'src/components/layout/GlobalContext'

import { widowRegex } from 'src/_helpers/dompurify'
import { formatTranslatorEntry } from 'src/i18n/translatorEntry'

export const useTranslateEntry = () => {
  const context = useContext(GlobalContext)

  const locale = context.currentLocale
  const translatorEntries = context.translatorEntries

  return (code, nl2br = false, parameters = {}) => {
    if (nl2br && typeof nl2br === 'object') {
      parameters = nl2br
      nl2br = false
    }
    const text = formatTranslatorEntry(translatorEntries?.[code], locale, code, parameters)
    const safeText = typeof text === 'string' ? text : ''
    if (!nl2br) {
      return safeText.replace(widowRegex, '$1\u00A0')
    }
    const arrayText = safeText.split('\n')
    return arrayText.map((line, index) => (
      <React.Fragment key={index}>
        {line.replace(widowRegex, '$1\u00A0')} {index + 1 < arrayText.length && <br />}
      </React.Fragment>
    ))
  }
}
